import { useSelector } from "react-redux";
import { extractValue } from "./utils";

export const useClientAddress = () => {
  const { clientData } = useSelector((state) => state.Client);

  return {
    unitNumber: extractValue(clientData, "unitNumber"),
    streetNumber: extractValue(clientData, "streetNumber"),
    street: extractValue(clientData, "street"),
    suburb: extractValue(clientData, "suburb"),
    state: extractValue(clientData, "state"),
    postCode: extractValue(clientData, "postCode"),
  }
};